import {v4 as uuidv4} from 'uuid';

export function getClientId(): string {
  return uuidv4();
}
